module.exports = __webpack_public_path__ + "img/usa.4296f07d.svg";